import _isEmpty from 'lodash/isEmpty';

import { RESUME_BUILDER_CATEGORY,USER_ACTIVITY_EVENTS } from 'utils/constant';

import { addUserGroupToData, getStateName } from '../utils';

import Service from './service';

// List of activity registered so far
/**
 * HTTP_ACTIVITY
 * RESUME_UPLOAD
 * AUTOCOMPLETE_SEARCH
 * SIGN_UP_POPUP
 * JOB_OPENING_JOB_CLICKED_DLP
 * JOB_OPENING_SAVED_DLP,
 * JOB_OPENING_DISMISSED_DLP,
 * JOB_OPENING_APPLIED_DLP
 * JOB_OPENING_VIEWED_DLP
 */

/**
 * log default HTTP_ACTIVITY with logActivity
 * @param {Object} payload logactivity payload detail
 * other params depending on the activity
 */
export function logActivity(payload = {}) {
  let data = {
    activityType: 'HTTP_ACTIVITY',
    url: payload.url || window.location.href,
    pageCategory: window.pageCategory,
    ...payload,
  };

  // FRON-10481 | RB landing page have different category than steps
  if (data.url?.includes('/resume-builder/')) {
    const urlSearchParams = new URLSearchParams(data.url?.slice(data.url.indexOf('?')));
    const { step } = Object.fromEntries(urlSearchParams.entries());
    data['pageCategory'] = step ? RESUME_BUILDER_CATEGORY.STEPS : RESUME_BUILDER_CATEGORY.LANDING;
  }

  if (data.activityType.startsWith('JOB_OPENING_')) {
    data = validateJobActivity(data);
  }

  addUserGroupToData(data);

  if (document.referrer && !payload.referer) {
    data.referer = document.referrer;
  }

  if (!data.referer) {
    data.referer = '';
  }

  console.log('logActivity payload', data);

  return new Promise((resolve, reject) => {
    Service.post('activity/log/', data)
      .then((res) => resolve(res))
      .catch((err) => {
        console.log(err);
      });
  });
}

/**
 * @param {Object} payload logactivity payload detail
 * @param {String} payload.searchOrigin type of activity
 * @param {String} payload.pageCategory Page name information from metadata
 *
 * @param {String} payload.major input value displayed
 * @param {String} payload.majorResultFound  value is selected or custom
 *
 * @param {String} payload.title  input value displayed
 * @param {String} payload.titleResultFound  value is selected or custom
 *
 * @param {String} payload.location  input value displayed
 * @param {String} payload.locationResultFound  value is selected or custom
 *
 * @param {String} payload.company  input value displayed
 * @param {String} payload.companyResultFound value is selected or custom
 *
 * @param {String} payload.college  input value displayed
 * @param {String} payload.ccollegeResultFound value is selected or custom
 * other params depending on the activity
 */
export const logAutoCompleteActivity = (payload = {}) => {
  if (
    payload &&
    (payload.location || payload.major || payload.title || payload.company || payload.college)
  ) {
    logActivity({
      ...payload,
      activityType: 'AUTOCOMPLETE_SEARCH',
    });
  }
};

export const logProfileUpdateActivity = (fieldUpdated, fieldChangedFrom, fieldChangedTo) => {
  if (fieldUpdated !== undefined && fieldChangedTo !== undefined) {
    const activityData = {
      fieldUpdated,
      fieldChangedFrom,
      fieldChangedTo,
      activityType: 'PROFILE_UPDATE',
      timestamp: Date.now(),
      date: new Date(),
      isoTime: new Date().toISOString(),
    };
    logActivity(activityData);
  }
};

/**
 * log all dlp related activity
 * @param {Object} job  job object with detail
 * @param {String} type dlp activity type
 * @param {Object} payload other detail to use with logActivity like referer instead document.referer
 */
export const logDLPJobActivity = (job = {}, type, payload = {}, pageCategory = '') => {
  if (!job || _isEmpty(job)) {
    return;
  }

  const { OBJcity, OBJstate, OBJstateCode } = job;

  const stateName = OBJstate || getStateName(OBJstateCode);

  const OBJjobTags = job.OBJjobTags || [];

  const isRemote =
    Array.isArray(OBJjobTags) &&
    OBJjobTags.some((tag) => typeof tag === 'string' && tag.toLowerCase() === 'remote');

  const jobLocation = {
    city: OBJcity || '',
    state: stateName,
    remote: isRemote,
  };

  const data = {
    originalCPC: job.originalCPC ? `${job.originalCPC}` : '',
    jobTitle: job.jobTitle,
    companyName: job.originalCompanyName || job.companyName || job.companyNameCPS,
    partnerName: job.source,
    searchTitle: job.OBJtitle,
    listingLocation: jobLocation,
    pageCategory: window.pageCategory,
    cpc: job.cpc || 0,
    listingHash: job.listingHash,
    url: window.location.href,
    postingDate: job.postingDate,
    jobUrl: job.OBJurl || job.url || job.jobUrl || '',
    refererPageCategory: pageCategory || window.pageCategory,
  };
  if (job.companyID) {
    data.companyID = job.companyID;
  }
  switch (type) {
    case USER_ACTIVITY_EVENTS.JOB_OPENING.JOB_OPENING_VIEWED_DLP:
    case USER_ACTIVITY_EVENTS.JOB_OPENING.JOB_OPENING_JOB_CLICKED_DLP:
    case USER_ACTIVITY_EVENTS.JOB_OPENING.JOB_OPENING_DISMISSED_DLP:
    case USER_ACTIVITY_EVENTS.JOB_OPENING.JOB_OPENING_APPLIED_DLP:
    case USER_ACTIVITY_EVENTS.JOB_OPENING.JOB_OPENING_SAVED_DLP:
    case USER_ACTIVITY_EVENTS.JOB_OPENING.JOB_OPENING_JOB_CLICKED:
      logActivity({
        activityType: type,
        ...data,
        ...payload,
        jobId: job.jobId || payload.jobId,
      });
      break;
    default:
      console.info(`there is no DLP ActivityType :${type}`);
      break;
  }
};

export const logJobUploadResumeActivity = (jobData, resumeLink, job) => {
  logActivity({
    ...jobData,
    jobId: job.jobId,
    partnerName: job.source,
    resumeLink,
    userId: `${window.userId}`,
    activityType: 'JOB_OPENING_RESUME_SUBMITTED',
  });
};

export const logCompanyReviewSubmittedActivity = (companyId, source) => {
  logActivity({
    companyID: companyId,
    src: source || 'survey-company-review',
    url: location.href,
    pageCategory: window.pageCategory,
    referer: document.referrer,
    userId: window.userId,
    timestamp: Date.now(),
    activityType: 'REVIEW_SUBMITTED',
  });
};

function validateJobActivity(data = {}) {
  const activityPayload = { ...data };

  const getValidString = (label = '') => `${label}`;

  if (data.originalCPC !== undefined && typeof data.originalCPC !== 'string') {
    activityPayload.originalCPC = getValidString(data.originalCPC);
  }

  if (data.secondaryUserId !== undefined && typeof data.secondaryUserId !== 'string') {
    activityPayload.secondaryUserId = getValidString(data.secondaryUserId);
  }

  return activityPayload;
}
